import copy from "copy-to-clipboard";
import authApi from "../api/authApi";
import { refActions } from "../store/refSlice";
import { APP_LINKS } from "../constants/app-links";

// Tiện ích cho trang smart-redirect /tai-app: nhận diện nền tảng + lưu mã giới thiệu
// (clipboard + cookie + ghi IP ở backend) để giữ mã qua bước cài app (deferred deep link).

/** Nhận diện nền tảng từ userAgent: "ios" | "android" | "desktop". */
export function detectPlatform() {
    if (typeof navigator === "undefined") return "desktop";
    const ua = navigator.userAgent || navigator.vendor || "";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
    if (/android/i.test(ua)) return "android";
    return "desktop";
}

/** Lấy mã ref hợp lệ (số) từ URL hiện tại, hoặc null. */
export function getRefFromUrl() {
    if (typeof window === "undefined") return null;
    const ref = new URLSearchParams(window.location.search).get("ref");
    return ref && /^\d+$/.test(ref.trim()) ? ref.trim() : null;
}

/** URL store theo nền tảng (desktop → null, không auto-redirect). */
export function getStoreUrl(platform) {
    if (platform === "ios") return APP_LINKS.ios;
    if (platform === "android") return APP_LINKS.android;
    return null;
}

/**
 * Lưu mã ref đa kênh (best-effort, không chặn UI):
 * - clipboard: app đọc lại lần mở đầu
 * - cookie + redux: phòng khi user đăng ký luôn trên web
 * - backend track-visit: ghi {ip, ref} để app khớp lại theo IP trong 10 phút
 */
export function persistReferral(ref, dispatch) {
    if (!ref) return;
    // Clipboard dùng tiền tố "LH" (sentinel) để app phân biệt CHẮC CHẮN mã giới thiệu với
    // số ngẫu nhiên user vừa copy (sđt, OTP, giá...). App chỉ nhận chuỗi dạng LH<digits>.
    try { copy(`LH${ref}`); } catch (_) { /* clipboard có thể bị chặn — bỏ qua */ }
    try { document.cookie = `ref=${ref}; path=/; max-age=2592000`; } catch (_) {}
    try { if (dispatch) dispatch(refActions.setRef(ref)); } catch (_) {}
    authApi.trackReferralVisit(ref).catch(() => { /* best-effort */ });
}
